<div class="row">
  <div class="col-11">
    <mat-form-field appearance="fill" style="width: 20%">
      <mat-label>Container</mat-label>
      <mat-select [(value)]="selectedContainerId" (selectionChange)="containerChange($event.value)">
        <mat-option>None</mat-option>
        @for (constainer of containerList; track constainer) {
          <mat-option [value]="constainer.id">{{constainer.name}}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="fill" style="width: 24%" class="ml-1">
      <mat-label>Type</mat-label>
      <mat-select [(value)]="selectedContainerTypeId" (selectionChange)="typeChange($event.value)">
        <mat-option>None</mat-option>
        @for (type of typeList; track type) {
          <mat-option [value]="type.id">{{type.name}}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="fill" style="width: 40%" class="ml-1">
      <mat-label>Status</mat-label>
      <mat-select [(value)]="selectedStatusId" (selectionChange)="statusChange($event.value)">
        <mat-option>None</mat-option>
        @for (status of statusList; track status) {
          <mat-option [value]="status.id">{{status.name}}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
</div>
<div class="pt-2">
  <div  class="col-md-12 col-12 pr-1 flex-grow-1 d-flex flex-column">
    <div appSetHeight [padding]="30" class="map">
      <div class="map-container">
        <div class="map-frame" #mapdiv>
          <div id="map"></div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-containers-popup [imageSrc]="selectedImage" [selectedId]="showAssetId" [containers]="selectedContainers" [isOpen]="isPopupOpen" (close)="closePopup()"></app-containers-popup>
